import { render } from "./Breadcrumb.vue?vue&type=template&id=65ad99ce&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=65ad99ce&scoped=true&lang=css"

import exportComponent from "D:\\wamp64\\www\\comd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ad99ce"]])

export default __exports__